function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-1.7%",
  y: "-1.7%",
  width: "106.7%",
  height: "106.7%",
  filterUnits: "objectBoundingBox",
  id: "sdsadsadaswqezxsfasfsadsadsadasda"
}, React.createElement("feOffset", {
  dx: 1,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
  in: "shadowBlurOuter1"
})), React.createElement("path", {
  d: "M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0z",
  id: "xxffafqefdgsdgsdgsfasfsafsafsafsfbxccxx"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#sdsadsadaswqezxsfasfsadsadsadasda)",
  xlinkHref: "#xxffafqefdgsdgsdgsfasfsafsafsafsfbxccxx"
}), React.createElement("use", {
  fill: "#F0AB00",
  xlinkHref: "#xxffafqefdgsdgsdgsfasfsafsafsafsfbxccxx"
})), React.createElement("path", {
  d: "M25 22.37v16.26",
  stroke: "#FFF",
  strokeWidth: 5,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M35 22.37v16.26",
  stroke: "#FFF",
  strokeWidth: 5,
  strokeLinecap: "round"
}));

var SvgBtnPause = function SvgBtnPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBtnPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-pause.e39580c0.svg";
export { ForwardRef as ReactComponent };